module.exports = require("!!vue-loader!../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./giud.md");


//////////////////
// WEBPACK FOOTER
// ./src/docs/giud.md
// module id = K7yA
// module chunks = 0